import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useMemo } from 'react'

export function useIsMarqiiUser() {
  const { userAttributes } = useCognitoAuth()

  return useMemo(() => {
    const userEmail = userAttributes?.email
    const isMarqiiUser = !!userEmail?.includes('@marqii')
    return { isMarqiiUser }
  }, [userAttributes?.email])
}
